import { useCallback } from 'react';
import {
  Create,
  Edit,
  Labeled,
  NumberInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  number,
  regex,
  required,
  useGetIdentity,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';

const queryOptions = { meta: { raw: true } };

export const FrameworksEdit = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const transform = useCallback(
    (data: any) => {
      console.log('data', data);

      return {
        ...data,
        lastUpdatedBy: userId,
        lastUpdatedAt: new Date(),
      };
    },
    [userId],
  );

  return (
    <Edit
      title={<EditTitle />}
      mutationMode="pessimistic"
      actions={false}
      transform={transform}
      queryOptions={queryOptions}
    >
      <EntityForm />
    </Edit>
  );
};

export const FrameworksCreate = () => {
  const userId = useGetIdentity().data?.id?.toString();

  const transform = useCallback(
    (data: any) => {
      console.log('data', data);

      const now = new Date();

      return {
        ...data,
        createdAt: now,
        createdBy: userId,
        deletedAt: now,
        deletedBy: userId,
      };
    },
    [userId],
  );

  return (
    <Create redirect="list" transform={transform}>
      <EntityForm />
    </Create>
  );
};

export const EditToolbar = () => (
  <Toolbar>
    <SaveButton label="Save" />
  </Toolbar>
);

export const EditTitle = () => {
  const record = useRecordContext();

  return <span>App Document: {record ? `${record.id}` : ''}</span>;
};

const pattern = '^[a-z]{3,}(-[a-z]+)?$';

const EntityForm = () => {
  const record = useRecordContext();

  return (
    <SimpleForm toolbar={<EditToolbar />}>
      {!record && (
        <TextInput
          label="ID"
          source="_id"
          fullWidth
          validate={[
            regex(
              new RegExp(pattern),
              `Invalid Pattern. Must match ${pattern}`,
            ),
            required(),
          ]}
        />
      )}
      {!!record && (
        <Labeled label="ID">
          <Chip label={record.id} />
        </Labeled>
      )}
      <NumberInput
        label="Sort Order"
        source="sortOrder"
        validate={[number()]}
        fullWidth
      />
      <TextInput
        label="Name"
        source="name"
        validate={[required()]}
        multiline
        fullWidth
      />
    </SimpleForm>
  );
};
